import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  inject,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { HMRService, HMRState } from '../../core/services/hmr.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-hmr-status',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    @if (hmrState.isEnabled && !environment.production) {
      <div class="hmr-status-indicator" [class.updated]="hmrState.hasUpdated">
        <div class="hmr-content">
          <span class="hmr-icon">🔥</span>
          <span class="hmr-text">HMR Active</span>
          @if (hmrState.updateCount > 0) {
            <span class="hmr-counter">
              {{ hmrState.updateCount }}
            </span>
          }
        </div>
        @if (hmrState.hasUpdated) {
          <div class="hmr-details">
            <small
              >Last update:
              {{ hmrState.lastUpdateTime | date: 'medium' }}</small
            >
          </div>
        }
      </div>
    }
  `,
  styles: [
    `
      .hmr-status-indicator {
        position: fixed;
        top: 10px;
        right: 10px;
        background: rgba(255, 140, 0, 0.9);
        color: white;
        padding: 8px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-family: monospace;
        z-index: 99;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
        min-width: 100px;
      }

      .hmr-status-indicator.updated {
        background: rgba(34, 197, 94, 0.9);
        animation: pulse 0.5s ease-in-out;
      }

      .hmr-content {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .hmr-icon {
        font-size: $font-size-12;
      }

      .hmr-counter {
        background: rgba(255, 255, 255, 0.2);
        padding: 2px 6px;
        border-radius: 10px;
        margin-left: auto;
      }

      .hmr-details {
        margin-top: 4px;
        opacity: 0.8;
      }

      @keyframes pulse {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.05);
        }
        100% {
          transform: scale(1);
        }
      }

      @media (max-width: 768px) {
        .hmr-status-indicator {
          top: 5px;
          right: 5px;
          padding: 6px 8px;
          font-size: 11px;
        }
      }
    `
  ]
})
export class HMRStatusComponent implements OnInit, OnDestroy {
  private hmrService = inject(HMRService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  hmrState: HMRState = {
    isEnabled: false,
    hasUpdated: false,
    lastUpdateTime: new Date(),
    updateCount: 0
  };

  environment = environment;
  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.hmrService.state$.subscribe((state) => {
        this.hmrState = { ...state };
        this.changeDetectorRef.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
